import React, { useEffect, useState } from "react";
import MonthRangePicker from "../../../components/MonthRangePicker";
import CheckboxButton from "../../../components/CheckboxButton";
import CustomButton from "../../../components/CustomButton";
import {Link, useNavigate} from "react-router-dom";
import { currentUserActions } from '../../../reducers/currentUser';
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import noAvatar from "../../../../assets/img/noAvatar.png";
import { getTalentDetail, getCareerInformation,
  updateCareerInformation, updateBasicInformation,
  mypageActions, createStatus, updateFullInformation, mypageUploadFileTempPost } from "../../../reducers/talentMypage";
import { formatName, formatYear, formatYearMonth, getAge, formatFullInformation, formatDate } from "./../../../utils/format";
import AvatarDialog from "../components/AvatarDialog";
import ConfirmPopup from "../../../components/ConfirmPopup";
import UnsaveConfirmPopup from "../../action/components/UnsaveConfirmPopup";
import { useSnackbar } from "notistack";
import CustomToast from "../../../components/CustomToast";
import { LoadingIcon, LoadingSpinner } from './../../../components/Icons'
import CustomIconButton from "../../../components/CustomIconButton";
import FileItem from "../../../components/FileItem";
import TextInput from "../../../components/TextInput";
import Dropdown from "../../../components/Dropdown";
import BasicInfoSection from "./components/BasicInfoSection";
import CareerSection from "./components/CareerSection";
import ReasonSection from "./components/ReasonSection";
import ConditionSection from "./components/ConditionSection";
import WorkLocationSection from "./components/WorkLocationSection";
import WorkStyleSection from "./components/WorkStyleSection";
import ProfessionSection from "./components/ProfessionSection";
import IndustrySection from "./components/IndustrySection";
import { downloadFileAttachment } from 'utils/util';
import i18n from 'i18next';
import { TALENT_FILE_TYPE, TALENT_TYPE, WORKING_AGE } from '../../../constants/index'
import { validateRequired, validateEmail, validateNameKatakana, isValidJoinDateLeaveDate } from "utils/validation"
import { getItemsDay, getItemsMonth, getItemsYear, getNameByObject, getObjectByName, getStableFile } from "utils/util";
import FileUploader from "../../../components/FileUploader";
interface CareerItem {
  description: string;
  join_date: string;
  leave_date: string;
  is_current: boolean;
}


const FullInfomation = ({ onClose, selectedUser }: any) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate();
  const { talent, errors, professionOptions, industryOptions, workingStyleOptions,
    cityOptions, initialData, residenceOptions } = useSelector((state: any) => state.talentMypage)
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const talentMypage = useSelector((state: any) => state.talentMypage)
  const talentInformation = talentMypage.talentDetail?.talent
  const [isSubmit, setSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const currentUser = useSelector((state: any) => state.currentUser)
  const { first_name, last_name, id } = currentUser.talentInfo
  const {isLoading, successImage, actionStatus, actionName } = useSelector((state: any) => state.talentMypage)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [action, setAction] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [unselectedOptions, setUnselectedOptions] = useState<string[]>([]);
  const [selectedOptionsCondition, setSelectedOptionsCondition] = useState<string[]>([]);
  const [unselectedOptionsCondition, setUnselectedOptionsCondition] = useState<string[]>([]);
  const [dataOtherReason, setDataOtherReason] = useState<string[]>([]);
  const [isDisplay, setDisplay] = useState(false)
  let reasons = talent?.last_company?.reason_resignation
  let reasonList = reasons ? reasons?.split(' | ') : []
  let reasonsListFull = talent?.last_company?.reason_resignation_full?.split(' | ') || [];
  let conditions = talent?.last_company?.expected_condition_new
  let conditionList = conditions ? conditions?.split(' | ') : [];
  let conditionsListFull = talent?.last_company?.expected_condition_full?.split(' | ') || [];
  const [dataOtherCondition, setDataOtherCondition] = useState<string[]>([]);
  const careerData = talentMypage?.careerData
  const [dataCareer, setDataCareer] = React.useState<CareerItem[]>([]);
  const [formData, setFormData] = useState(initialData);
  const [dayOptions, setDayOptions] = useState(getItemsDay());
  const [unsaveConfirmOpen, setUnsaveConfirmOpen] = useState(false);
  const [selectedProfession, setSelectedProfession] = useState<any>(null);
  const [profession1Options, setProfession1Options] = useState([]);
  const [profession2Options, setProfession2Options] = useState([]);
  const [profession3Options, setProfession3Options] = useState([]);
  const [industry1Options, setIndustry1Options] = useState([]);
  const [industry2Options, setIndustry2Options] = useState([]);
  const [industry3Options, setIndustry3Options] = useState([]);
  const [isInitOptions, setIsInitOptions] = useState(false);
  const dataYearJoinLeave = getItemsYear(null);
  const dataMonthJoinLeave = getItemsMonth();
  const dataDayJoinLeave = getItemsDay();
  const dataYear = getItemsYear(new Date().getFullYear() - WORKING_AGE, 100 - WORKING_AGE);
  const dataMonth = getItemsMonth();
  const dataDate = getItemsDay();
  const [isFileChanged, setIsFileChanged] = useState({
    RESUME: false,
    CV: false,
    OTHER: false,
  })
  const [fileLoading, setFileLoading] = useState<Record<string, boolean>>({});

  useEffect(() => {
      if(isInitOptions) {
        return
      }
      let profession1 = null
      let profession2 = null
      let profession3 = null
      if(talentMypage?.talent && professionOptions) {
          profession1 = professionOptions.find((item:any) => item?.id === talentMypage?.talent?.profession_1_id);
          profession2 = professionOptions.find((item:any) => item?.id === talentMypage?.talent?.profession_2_id);
          profession3 = professionOptions.find((item:any) => item?.id === talentMypage?.talent?.profession_3_id);
          setProfession1Options(professionOptions.filter(item => item.level == 1))
          if(talentMypage?.talent?.profession_1_id) {
              setProfession2Options(professionOptions.filter(item => item.parent_id == profession1.code && item.level == 2))
          }
          if(talentMypage?.talent?.profession_2_id) {
              setProfession3Options(professionOptions.filter(item => item.parent_id == profession2.code && item.level == 3))
          }
      }
      let industry1 = null
      let industry2 = null
      let industry3 = null
      if(talentMypage?.talent && industryOptions) {
        industry1 = industryOptions.find((item:any) => item?.id === talentMypage?.talent?.industry_1_id);
        industry2 = industryOptions.find((item:any) => item?.id === talentMypage?.talent?.industry_2_id);
        industry3 = industryOptions.find((item:any) => item?.id === talentMypage?.talent?.industry_3_id);
        setIndustry1Options(industryOptions.filter(item => item.level == 1))
        if(talentMypage?.talent?.industry_1_id) {
            setIndustry2Options(industryOptions.filter(item => item.parent_id == industry1.code && item.level == 2))
        }
        if(talentMypage?.talent?.industry_2_id) {
            setIndustry3Options(industryOptions.filter(item => item.parent_id == industry2.code && item.level == 3))
        }
      }
      setFormData((prev: any) => ({
        ...prev,
        profession_1: profession1,
        profession_2: profession2,
        profession_3: profession3,
        industry_1: industry1,
        industry_2: industry2,
        industry_3: industry3,
      }));

      setIsInitOptions(true)
  }, [talentMypage, professionOptions, industryOptions])

  const handleBlur = (event: any) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setOptionsOpen(false);
    }
  };
  const getObjectById = (itemId, options) => {
    if(itemId && Array.isArray(options) && options.length > 0) {
      return options.find((item:any) => item?.id === itemId);
    }
    return null;
  };
  useEffect(() => {
    dispatch(mypageActions.setErrors({}));
    dispatch(getCareerInformation())
  }, []);
  useEffect(() => {
    if (["updateBasicInformation", "updateInformation"].includes(action) && isSubmit) {
      setMessage("")
      setSubmit(false)
    }
  }, [action])
  useEffect(() => {
    if (talent) {
      reasonList = reasons ? reasons?.split(' | ') : []
      conditionList = conditions ? conditions?.split(' | ') : []
      setSelectedOptions(reasons ? reasons?.split(' | ') : [])
      setUnselectedOptions(reasonsListFull.filter((item: string) => !reasonList.includes(item)))
      setSelectedOptionsCondition(conditions ? conditions?.split(' | ') : [])
      setUnselectedOptionsCondition(conditionsListFull.filter((item: string) => !conditionList.includes(item)))
    }
  }, [talent]);
  useEffect(() => {
    if (actionStatus == 'fulfilled' && actionName == 'getTalentDetail') {
      setDayOptions(getItemsDay(talent?.birth_year, talent?.birth_month));
      setFormData({
        first_name: talent?.first_name || '',
        last_name: talent?.last_name || '',
        first_name_kana: talent?.first_name_kana || '',
        last_name_kana: talent?.last_name_kana || '',
        email: talent?.email || '',
        gender: talent?.gender,
        do_want_news_email: talent?.do_want_news_email,
        do_want_scout_email: talent?.do_want_scout_email,
        profession_1: getObjectById(talent?.profession_1_id, professionOptions),
        profession_2: getObjectById(talent?.profession_2_id, professionOptions),
        profession_3: getObjectById(talent?.profession_3_id, professionOptions),
        industry_1: getObjectById(talent?.industry_1_id, industryOptions),
        industry_2: getObjectById(talent?.industry_2_id, industryOptions),
        industry_3: getObjectById(talent?.industry_3_id, industryOptions),
        working_style_1: getObjectById(talent?.working_style_1_id, workingStyleOptions),
        working_style_2: getObjectById(talent?.working_style_2_id, workingStyleOptions),
        working_style_3: getObjectById(talent?.working_style_3_id, workingStyleOptions),
        preferred_city_1: getObjectById(talent?.preferred_city_1_id, cityOptions),
        preferred_city_2: getObjectById(talent?.preferred_city_2_id, cityOptions),
        preferred_city_3: getObjectById(talent?.preferred_city_3_id, cityOptions),
        city: getObjectByName(talent?.city, residenceOptions),
        join_company_year: getObjectById(talent?.last_company?.join_company_year, dataYearJoinLeave),
        join_company_month: getObjectById(talent?.last_company?.join_company_month, dataMonthJoinLeave),
        leave_company_year: getObjectById(talent?.last_company?.leave_company_year, dataYearJoinLeave),
        leave_company_month: getObjectById(talent?.last_company?.leave_company_month, dataMonthJoinLeave),
        leave_company_day: getObjectById(talent?.last_company?.leave_company_day, dataDayJoinLeave),
        birth_year: getObjectById(talent?.birth_year, dataYear),
        birth_month: getObjectById(talent?.birth_month, dataMonth),
        birth_day: getObjectById(talent?.birth_day, dataDate),
        RESUME: talent?.last_company?.uploaded_files?.find((file:any) => file.type === TALENT_FILE_TYPE.RESUME) || null,
        CV: talent?.last_company?.uploaded_files?.find((file:any) => file.type === TALENT_FILE_TYPE.CV) || null,
        OTHER: talent?.last_company?.uploaded_files?.find((file:any) => file.type === TALENT_FILE_TYPE.OTHER) || null,
      })
    }
  }, [actionStatus, actionName]);

  const signOutUser = () => {
    dispatch(currentUserActions.signOutUser({ navigate, view: 'talent' }))
  };

  const handleAvatarChange = async (file: any) => {
    if (!file) {
      setIsConfirmOpen(false);
      const data = {
        formData: {
          ...talent,
          avatar: null,
          delete_avatar: true,
          change_point: 'image'
        },
      };
      const resultImage = await dispatch(updateBasicInformation(data))
      setMessage(resultImage.payload.message)
      setAction("updateInformation")
      setSubmit(true)
    }
    setIsOpen(false);
  };
  
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setDisplay(true)
  };
  const handleBlurInput = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value.trim(),
    }));
  };
  useEffect(() => {
    if (careerData) {
      setDataCareer(careerData);
    }
  }, [careerData])
  
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };
  const validateSelectedOptions = (
    originList: string[],
    selectedOptions: string[],
    unselectedOptions: string[],
    dataOther: string[],
    maxLengthItem: number
  ) => {
    let items = [...selectedOptions, ...dataOther.filter(item => item.trim())].join(" | ").trim();
    let itemFull = originList.filter(item => items.includes(item) || unselectedOptions.includes(item))
      .map(item => item.trim()).join(" | ").trim();
    let itemCheckUniqueArr = [...selectedOptions, ...dataOther.filter(item => item.trim()), ...unselectedOptions];
    if (new Set(itemCheckUniqueArr).size !== itemCheckUniqueArr.length) return { error: "重複しています。" };
    if (itemFull.length > 2000) return { error: "2000文字を超えてます。" };
    return { value: { item: items, itemFull: itemFull } };
  };

  const validateCareer = (dataCareer: any) => {
    if(dataCareer.length == 0) {
      return {};
    }
    for (const item of dataCareer) {
      if (!item.description || !item.join_date || (!item.is_current && !item.leave_date)) {
        return { error: "職場、入社日、退社日が必須です。" };
      }
    }
    if (dataCareer.filter((item: { is_current: any; }) => item.is_current).length > 1) {
      return { error: "現職が存在しています。" };
    }
    const seen = new Set();
    for (const item of dataCareer) {
      const { description, join_date, leave_date } = item;
      const leaveDateFormatted = leave_date ? leave_date.substring(0, 7) : "";
      const key = JSON.stringify({ description, join_date, leave_date: leaveDateFormatted });
      if (seen.has(key)) {
        return { error: "重複しています。" };
      }
      seen.add(key);
    }
    return {};
  }
  const setValueDate = (date: any, type: any) => {
    if (!date) {
      return 0
    }
    if (type == 'year') {
      return parseInt(date?.slice(0, 4));
    } else if (type == 'month') {
      return parseInt(date?.slice(5, 7));
    } else {
      return parseInt(date?.slice(8, 10));
    }
  }

  const getRequestData = (reasonValue, conditionValue) => {    
    return {
      ...talentInformation,
      gender_id: formData?.gender?.id ? formData?.gender?.id : null,
      change_point: 'fullInformation',
      first_name: formData?.first_name,
      last_name: formData?.last_name,
      first_name_kana: formData?.first_name_kana,
      last_name_kana: formData?.last_name_kana,
      email: formData?.email,
      do_want_news_email: true ? formData?.do_want_news_email == 'true' || formData?.do_want_news_email == true : false,
      do_want_scout_email: true ? formData?.do_want_scout_email == 'true' || formData?.do_want_scout_email == true : false,
      city: getNameByObject(formData?.city),
      join_company_year: formData?.join_company_year?.id ? formData?.join_company_year?.id : null,
      join_company_month: formData?.join_company_month?.id ? formData?.join_company_month?.id : null,
      leave_company_year: formData?.leave_company_year?.id ? formData?.leave_company_year?.id : null,
      leave_company_month: formData?.leave_company_month?.id ? formData?.leave_company_month?.id : null,
      leave_company_day: formData?.leave_company_day?.id ? formData?.leave_company_day?.id : null,
      birth_year: formData?.birth_year?.id ? formData?.birth_year?.id : null,
      birth_month: formData?.birth_month?.id ? formData?.birth_month?.id : null,
      birth_day: formData?.birth_day?.id ? formData?.birth_day?.id : null,
      reason_resignation: reasonValue?.item,
      reason_resignation_full: reasonValue?.itemFull,
      expected_condition: conditionValue?.item,
      expected_condition_full: conditionValue?.itemFull,
      change_job_status_id: null, 
      work_parttime_status_id: null, 
      profession_1_id: formData?.profession_1 ? formData?.profession_1?.id : null,
      profession_2_id: formData?.profession_2 ? formData?.profession_2?.id : null,
      profession_3_id: formData?.profession_3 ? formData?.profession_3?.id : null,
      industry_1_id: formData?.industry_1 ? formData?.industry_1?.id : null,
      industry_2_id: formData?.industry_2 ? formData?.industry_2?.id : null,
      industry_3_id: formData?.industry_3 ? formData?.industry_3?.id : null,
      working_style_1_id: formData?.working_style_1 ? formData?.working_style_1?.id : null,
      working_style_2_id: formData?.working_style_2 ? formData?.working_style_2?.id : null,
      working_style_3_id: formData?.working_style_3 ? formData?.working_style_3?.id : null,
      preferred_city_1_id: formData?.preferred_city_1 ? formData?.preferred_city_1?.id : null,
      preferred_city_2_id: formData?.preferred_city_2 ? formData?.preferred_city_2?.id : null,
      preferred_city_3_id: formData?.preferred_city_3 ? formData?.preferred_city_3?.id : null,
      career: JSON.stringify(dataCareer),
      cv_file_temp_id: isFileChanged['CV'] && formData['CV']?.file ? formData['CV']?.file_id : null,
      upload_cv_file_path: !isFileChanged['CV'] && formData['CV'] ? formData['CV']?.file_path : null,
      resume_file_temp_id: isFileChanged['RESUME'] && formData['RESUME']?.file ? formData['RESUME']?.file_id : null,
      upload_resume_file_path: !isFileChanged['RESUME'] && formData['RESUME'] ? formData['RESUME']?.file_path : null,
      other_file_temp_id: isFileChanged['OTHER'] && formData['OTHER']?.file ? formData['OTHER']?.file_id : null,
      upload_other_file_path: !isFileChanged['OTHER'] && formData['OTHER'] ? formData['OTHER']?.file_path : null
    };
  }

  const resetFileChangeState = () => {
    setIsFileChanged({
      RESUME: false,
      CV: false,
      OTHER: false,
    })
  }

  const handleSaveAll = async (event: React.FormEvent) => {
    event.preventDefault();
    if (Object.values(fileLoading).some((value) => value)) {
      showToast('メッセージ', i18n.t('MSG_TALENT_FILE_UPLOADING_WARNING'), 'loading');
      return;
    }
    if (isLoading) return;
    dispatch(mypageActions.setErrors(null));
    const reasonValidation = validateSelectedOptions(reasonsListFull, selectedOptions, unselectedOptions, dataOtherReason, 7);
    const conditionValidation = validateSelectedOptions(conditionsListFull, selectedOptionsCondition, unselectedOptionsCondition, dataOtherCondition, 10);
    const careerValidation = validateCareer(dataCareer);
    let errors: any = {};
    if (reasonValidation.error) errors.reason_resignation = reasonValidation.error;
    if (conditionValidation.error) errors.expected_condition = conditionValidation.error;
    if (careerValidation.error) errors.career = careerValidation.error;
    const check_email = validateEmail(formData.email);
    if (check_email !== true) {
      errors.email = check_email
    }
    const check_first_name = validateRequired(formData.first_name, '名');
    if (check_first_name !== true) {
      errors.first_name = check_first_name
    }
    const check_last_name = validateRequired(formData.last_name, '姓');
    if (check_last_name !== true) {
      errors.last_name = check_last_name
    }
    let check_last_name_kana = validateRequired(formData.last_name_kana, 'セイ');
    if (check_last_name_kana !== true) {
      errors.last_name_kana = check_last_name_kana
    } else {
      check_last_name_kana = validateNameKatakana(formData.last_name_kana, 'セイ');
      if (check_last_name_kana !== true) {
        errors.last_name_kana = check_last_name_kana
      }
    }
    let check_first_name_kana = validateRequired(formData.first_name_kana, 'メイ');
    if (check_first_name_kana !== true) {
      errors.first_name_kana = check_first_name_kana
    } else {
      check_first_name_kana = validateNameKatakana(formData.first_name_kana, 'メイ');
      if (check_first_name_kana !== true) {
        errors.first_name_kana = check_first_name_kana
      }
    }
    const check_birth_day = validateRequired(formData.birth_day, '日');
    if (check_birth_day !== true) {
      errors.birth_day = check_birth_day
    }
    if (talent?.last_company?.type?.value != TALENT_TYPE.INTERNAL) {
      const check_profession_1 = validateRequired(formData.profession_1, '職種１');
      if (check_profession_1 !== true) {
        errors.profession_1 = check_profession_1
      }
      const check_profession_2 = validateRequired(formData.profession_2, '職種２');
      if (check_profession_2 !== true) {
        errors.profession_2 = check_profession_2
      }
      const check_profession_3 = validateRequired(formData.profession_3, '職種３');
      if (check_profession_3 !== true) {
        errors.profession_3 = check_profession_3
      }
      const check_industry_1 = validateRequired(formData.industry_1, '業種１');
      if (check_industry_1 !== true) {
        errors.industry_1 = check_industry_1
      }
      const check_industry_2 = validateRequired(formData.industry_2, '業種２');
      if (check_industry_2 !== true) {
        errors.industry_2 = check_industry_2
      }
      const check_industry_3 = validateRequired(formData.industry_3, '業種３');
      if (check_industry_3 !== true) {
        errors.industry_3 = check_industry_3
      }
    }
    const check_join_company_date = isValidJoinDateLeaveDate(formData?.join_company_year?.id, formData.join_company_month?.id, formData.leave_company_year?.id, formData.leave_company_month?.id);
    if (check_join_company_date !== true) {
      errors.join_company_year = '入社年月は退社年月より後にできない。'
    }
    if (Object.keys(errors).length > 0) {
      dispatch(mypageActions.setErrors(errors));
      // Scroll to first error
      setTimeout(() => {
        const firstError = document.querySelector("p.alu-text-error");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 200);
      return;
    }
    dispatch(updateFullInformation({requestBody: getRequestData(reasonValidation.value, conditionValidation.value)}));
    resetFileChangeState();
    setDisplay(false);
    setDataOtherReason([]);
    setDataOtherCondition([]);
    setSubmit(true)
    dispatch(mypageActions.setErrors({}));
  };
  const userOptions = [
    { name: "マイページ", onClick: () => navigate("/talent/mypage"), },
    { name: "ログアウト", onClick: signOutUser, },
  ];
  const showToast = (title: string, message: string, variant: string) => {
    enqueueSnackbar("I love snacks.", {
      autoHideDuration: 7000,
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };
  const handleChangeFile = async (file:any, item) => {
    if (Object.values(fileLoading).some((value) => value)) {
      showToast('メッセージ', i18n.t('MSG_TALENT_FILE_UPLOADING_WARNING'), 'loading');
      return;
    }
    setFileLoading((prev) => ({...prev, [item]: true}));

    try {
      const stableFile = await getStableFile(file);
      const res = await dispatch(mypageUploadFileTempPost({
        formData: {
          file: stableFile,
          type: item,
          is_temp: true
        }
      }));
      if(res && res.payload) {
        if(res.payload.success) {
          setFormData((prev) => ({
            ...prev,
            [item]: {
              ...prev[item],
              file_name: stableFile.name,
              file_path: URL.createObjectURL(stableFile),
              created_at: null,
              file: stableFile,
              file_id: res.payload.data
            },
          }));
          setIsFileChanged((prev) => ({
            ...prev,
            [item]: true,
          }));
          setDisplay(true);
        } else {
          const errMsg = typeof res.payload === 'string'
            ? res.payload
            : (res.payload?.message || i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
          showToast("メッセージ", errMsg, "error");
        }
      }
    } catch (error) {
      showToast("メッセージ", i18n.t('MSG_TALENT_UPLOAD_FILE_EMPTY_OR_UNREADABLE'), "error");
    } finally {
      setFileLoading((prev) => ({...prev, [item]: false}));
    }
  }

  const handleClearFile = (item:any) => {
    if (Object.values(fileLoading).some((value) => value)) {
      showToast('メッセージ', i18n.t('MSG_TALENT_FILE_UPLOADING_WARNING'), 'loading');
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [item]: null,
    }));
    setIsFileChanged((prev) => ({
      ...prev,
      [item]: true,
    }));
    setDisplay(true);
  }

  const handleDownloadFileAttachment = async (url: string, filename?: string) => {
    if (Object.values(fileLoading).some((value) => value)) {
      showToast('メッセージ', i18n.t('MSG_TALENT_FILE_UPLOADING_WARNING'), 'loading');
      return;
    }
    try {
      await downloadFileAttachment(url, filename);
    } catch (error) {
      showToast("メッセージ", i18n.t('MSG_GLOBAL_FILE_NOT_EXIST_OR_DELETED'), "error");
    }
  };

  return (
    <>
      <div className="w-full h-full bg-white pt-4 py-2 px-6 alu-panel-box-shadow overflow-y-auto custom-scrollbar">
        <div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <CustomIconButton onClick={() => !isDisplay ? onClose() : setUnsaveConfirmOpen(true)} size="sm" variant="icononly">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.4099 16.59L10.8299 12L15.4099 7.41L13.9999 6L7.99991 12L13.9999 18L15.4099 16.59Z" fill="#808080"/></svg>
              </CustomIconButton>
              <h2 className="text-base font-bold alu-text-base-2">マイページ</h2>
            </div>
            <CustomButton variant="text" onClick={handleSaveAll} disabled={isLoading || !isDisplay}>保存</CustomButton>
          </div>
          <h2 className="md:hidden text-xs font-bold alu-text-base-1 mt-1 pl-6">{currentUser?.talentInfo?.company?.name}</h2>
        </div>
        <form onSubmit={handleSubmit} className="mt-6 w-full flex flex-col">
          <div className="mb-6 inline-flex items-center gap-6">
            <div className="relative">
              <img onClick={() => setIsOpen(true)} src={talent?.avatar ? talent?.avatar : noAvatar} className="w-20 h-20 rounded-full object-cover" alt="Avatar" />
              <label onClick={() => setIsOpen(true)} htmlFor="avatar" className="absolute bottom-[-10px] right-[-10px] z-index[9rem] p-1 bg-white rounded-full hover:cursor-pointer" >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clipPath="url(#clip0_13103_9111)">
                    <path d="M9.99967 12.6693C11.4724 12.6693 12.6663 11.4754 12.6663 10.0026C12.6663 8.52984 11.4724 7.33594 9.99967 7.33594C8.52691 7.33594 7.33301 8.52984 7.33301 10.0026C7.33301 11.4754 8.52691 12.6693 9.99967 12.6693Z" fill="#808080" />
                    <path d="M7.50033 1.66406L5.97533 3.33073H3.33366C2.41699 3.33073 1.66699 4.08073 1.66699 4.9974V14.9974C1.66699 15.9141 2.41699 16.6641 3.33366 16.6641H16.667C17.5837 16.6641 18.3337 15.9141 18.3337 14.9974V4.9974C18.3337 4.08073 17.5837 3.33073 16.667 3.33073H14.0253L12.5003 1.66406H7.50033ZM10.0003 14.1641C7.70033 14.1641 5.83366 12.2974 5.83366 9.99739C5.83366 7.6974 7.70033 5.83073 10.0003 5.83073C12.3003 5.83073 14.167 7.6974 14.167 9.99739C14.167 12.2974 12.3003 14.1641 10.0003 14.1641Z" fill="#808080" />
                  </g>
                  <defs><clipPath id="clip0_13103_9111"><rect width="20" height="20" fill="white" /></clipPath></defs>
                </svg>
              </label>
            </div>
            <p className="alu-text-base-2 text-xl font-bold">{formatName(first_name, last_name)}</p>
          </div>
          <div className="w-full pb-8 border-b alu-border">
            <BasicInfoSection formData={formData} setFormData={setFormData} setValueDate={setValueDate} dayOptions={dayOptions} setDayOptions={setDayOptions} setDisplay={setDisplay} />
          </div>
          <div className="mt-8 w-full pb-8 border-b alu-border">
            <CareerSection dataCareer={dataCareer} setDataCareer={setDataCareer} setDisplay={setDisplay} validateCareer={validateCareer} />
          </div>
          {talent?.last_company?.type?.value != TALENT_TYPE.INTERNAL && <div className="mt-8 w-full pb-8 border-b alu-border">
            <h2 className="text-base font-bold alu-text-base-2 mb-2">経歴書類のアップロード</h2>
            <p className="text-sm alu-text-base-1 mb-4">対応形式：PDF、Excel、Word（最大 32 MB）</p>
            <div className="flex flex-col gap-4">
              {["RESUME", "CV", "OTHER"].map((item) => {
                let file = formData[item];

                return (
                  <div key={item}>
                    <p className="text-sm alu-text-base-2 font-bold mb-2">{item === "RESUME" ? "履歴書" : item === "CV" ? "職務経歴書" : "その他のファイル"}</p>
                    {fileLoading[item] ? (
                      <div className="w-full h-[10rem] border border-dashed border-[#E0E0E0] flex items-center justify-center">
                        <LoadingIcon />
                      </div>
                    ) : file ? 
                      <FileItem 
                        file={file}
                        onFileClick={() => handleDownloadFileAttachment(file.file_path, file.file_name)}
                        handleClearFile={() => handleClearFile(item)} 
                      /> 
                      : 
                      <FileUploader onFileChange={(file) => handleChangeFile(file, item)} />
                    }
                  </div>
                )
              })}
            </div>
          </div>}
          <div className="mt-8 w-full pb-8 hidden border-b alu-border">
            <ReasonSection reasonsListFull={reasonsListFull} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions}
              dataOtherReason={dataOtherReason} setDataOtherReason={setDataOtherReason} setUnselectedOptions={setUnselectedOptions} setDisplay={setDisplay}/>
          </div>
          <div className="mt-8 w-full pb-8 border-b alu-border">
            <ConditionSection conditionsListFull={conditionsListFull} selectedOptionsCondition={selectedOptionsCondition} setSelectedOptionsCondition={setSelectedOptionsCondition}
              dataOtherCondition={dataOtherCondition} setDataOtherCondition={setDataOtherCondition} setUnselectedOptionsCondition={setUnselectedOptionsCondition} setDisplay={setDisplay} />
          </div>
          <div className="mt-8 w-full">
            <WorkLocationSection formData={formData} setFormData={setFormData} cityOptions={cityOptions} setDisplay={setDisplay}/>
          </div>
          <div className="mt-8 w-full">
            <WorkStyleSection formData={formData} setFormData={setFormData} workingStyleOptions={workingStyleOptions} setDisplay={setDisplay}/>
          </div>
          <div className="mt-8 w-full">
            <ProfessionSection formData={formData} setFormData={setFormData} professionOptions={professionOptions}
              profession1Options={profession1Options} profession2Options={profession2Options} profession3Options={profession3Options}
              setProfession2Options={setProfession2Options} setProfession3Options={setProfession3Options} setDisplay={setDisplay}/>
          </div>
          <div className="mt-8 w-full pb-8 border-b alu-border">
            <IndustrySection formData={formData} setFormData={setFormData} industryOptions={industryOptions}
              industry1Options={industry1Options} industry2Options={industry2Options} setIndustry2Options={setIndustry2Options}
              industry3Options={industry3Options} setIndustry3Options={setIndustry3Options} setDisplay={setDisplay}/>
          </div>
          <div className="mt-8 w-full mb-[4.375rem]">
            <div className="flex flex-wrap gap-4 items-center mb-2"><p className="alu-text-base-2 text-base font-bold">通知設定</p></div>
            <div className="flex flex-wrap gap-1">
              <CheckboxButton name={"receiveNewsEmail"} label={"新着ニュース情報をメールで受け取る"} value={formData.do_want_news_email}
                  onChange={(value: any) => { setFormData((prev) => ({ ...prev, do_want_news_email: !formData.do_want_news_email })); setDisplay(true); }}/>
              <CheckboxButton name={"receiveScoutEmail"} label={"スカウトの通知をメールで受け取る"} value={formData.do_want_scout_email}
                  onChange={(value: any) => { setFormData((prev) => ({ ...prev, do_want_scout_email: !formData.do_want_scout_email })); setDisplay(true); }}/>
            </div>
          </div>
          <div className="w-full">
            <CustomButton disabled={!isDisplay} onClick={handleSaveAll} width="full" size="md" className={(isDisplay)
                ? "w-full bg-alu-primary text-white py-3 px-6 rounded hover:bg-[#ea6d00]"
                : "w-full font-bold bg-alu-primary text-white py-3 px-6 rounded hover:bg-[#ea6d00] disabled:bg-[#BBB] flex justify-center gap-2"}>
              <p>{isLoading ? "保存中..." : "保存"}</p>
              {isLoading && (<span><LoadingSpinner /></span>)}
            </CustomButton>
          </div>
        </form>
      </div>
      <AvatarDialog file={talent?.avatar} open={isOpen} onClose={() => setIsOpen(false)} onConfirm={handleAvatarChange} onConfirmPopupOpen={() => setIsConfirmOpen(true)} />
      {isConfirmOpen && <ConfirmPopup width={360} open={isConfirmOpen} onClose={() => setIsConfirmOpen(false)} confirmContent={"現在使用しているプロフィール画像を削除しますか？"} onConfirm={() => handleAvatarChange(null)} isLoading={isLoading} />}
      {unsaveConfirmOpen && <UnsaveConfirmPopup
        open={unsaveConfirmOpen}
        onClose={() => setUnsaveConfirmOpen(false)}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={() => onClose()}
      />}
    </>
  );
};
export default FullInfomation;